/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePortfolioCommand } from '../../models/create-portfolio-command';
import { CreatePortfolioCommandResult } from '../../models/create-portfolio-command-result';

export interface ApiPortfolioCreatePortfolioPost$Params {
      body?: CreatePortfolioCommand
}

export function apiPortfolioCreatePortfolioPost(http: HttpClient, rootUrl: string, params?: ApiPortfolioCreatePortfolioPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatePortfolioCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPortfolioCreatePortfolioPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreatePortfolioCommandResult>;
    })
  );
}

apiPortfolioCreatePortfolioPost.PATH = '/api/Portfolio/CreatePortfolio';
